<template>
  <div>
    <v-file-input
      ref="fileInput"
      v-model="imageFile"
      show-size
      accept="image/*"
      label="ファイル"
      :rules="[sizeValidation]"
      persistent-hint
      :hint="hint"
    >
      <template v-slot:label>
        <InputLabel :labelName="labelName" :required="requiredImageFile" />
      </template>
    </v-file-input>
    <div
      class='p-image-upload-frame'
      :class="{pImageUploadFrameEnter: isEnter}"
      @dragleave="dragLeave"
      @dragover.prevent="dragOver"
      @drop.prevent="dropFile"
    >
      <template v-if="imagePreviewURL">
        <div class="p-image-upload-thumbnail-wrap">
          <img
            :src="imagePreviewURL"
            class="p-image-upload-thumbnail"
            :style="{ width: thumbnailWidth, height: thumbnailHeight }"
          />
        </div>
      </template>
      <template v-else>
        <div class='p-image-upload-frame-explain-wrap'>
          <span class='p-image-upload-frame-explain'>ドラッグ&ドロップでの画像アップロードはこちら。</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  components: {
    InputLabel
  },
  mixins: [formValidationUtils],
  props: {
    labelName: {
      type: String,
      required: true
    },
    propsImagePreviewURL: {
      type: String
    },
    requiredImageFile: {
      type: Boolean,
      default: false
    },
    thumbnailWidth: {
      type: String
    },
    thumbnailHeight: {
      type: String
    },
    hint: {
      type: String
    }
  },
  data: function () {
    return {
      imageFile: null,
      imagePreviewURL: null,
      isEnter: false
    }
  },
  mounted () {
    this.imagePreviewURL = this.propsImagePreviewURL
  },
  watch: {
    imageFile (value) {
      if (value) {
        this.imagePreviewURL = URL.createObjectURL(value)
        URL.revokeObjectURL(value)
      } else {
        this.imagePreviewURL = null
      }
      this.$emit('change-image-file', value)
    },
    propsImagePreviewURL () {
      if (this.propsImagePreviewURL) {
        this.imagePreviewURL = this.propsImagePreviewURL
      }
    }
  },
  methods: {
    dragLeave () {
      this.isEnter = false
    },
    dragOver () {
      this.isEnter = true
    },
    dropFile () {
      this.imageFile = [...event.dataTransfer.files][0]
      this.isEnter = false
    }
  }
}
</script>

<style scoped>
.p-image-upload-frame {
  width: 100%;
  height: 150px;
  margin-bottom: 20px;
  text-align: center;
  background-color: #dbdbdb;
  border: 3px dotted #8f8f8f;
}
.pImageUploadFrameEnter {
  background-color: #f5f5f5;
  border: 3px dotted #000cff;
}
.p-image-upload-frame-explain-wrap {
  margin-top: 55px;
}
.p-image-upload-frame-explain {
  font-size: 12px;
  font-weight: 600;
  color: #8f8f8f;
  margin: 0 10px;
}
.pImageUploadFrameExplainEnter {
  color: #000cff;
}
.p-image-upload-thumbnail-wrap {
  width: fit-content;
  height: calc(100% - 10px);
  margin: 5px auto 0;
  display: flex;
  align-items: center;
}
.p-image-upload-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
